import React, {useContext} from "react";
import {useState} from "react";
import {userServices} from "../../services";
import {FullDate} from "../tools/delivery-tools";
import {ShortDate} from "../tools/delivery-tools";
import ModalDriverInfoLite from "../modals/driver-info-lite";
import {notification} from "antd";
import {unloadingsService} from "../../services/unloadings.services";
import {
  UNLOADING_CANCELED,
  UNLOADING_COMPLETED,
  UNLOADING_ON_UNLOADING,
  UNLOADING_PLANNED
} from "../../helpers/unloading_status.helper";
import {CANCEL_UNLOADING, CHANGE_STATUS_UNLOADING, CREATE_UNLOADING, ARCHIVE_UNLOADING} from "../../helpers/user_permission.helper";
import {AppContext} from "../../contexts/app-context";
import i18n from "../../i18n";
import {carcassTypes, getTranslatedConstant, unloadPackageTypes} from "../../helpers/translate.helpers";

export default function UnloadingItemContent({
                                               unloading,
                                               contentVisible,
                                               setContentVisible,
                                               setNeedUpdate,
                                             }) {

  let user = userServices.getUser();
  const isUserStaff = !!user.info.isStaff;
  const appContext = useContext(AppContext);

  let btnShowDriverInfo = null;
  let btnStartUnloading = null;
  let btnCompleteUnloading = null;
  let btnCancelUnloading = null;

  const [showModalDriverInfo, setShowDriverModalInfo] = useState(false);

  const translatedPackageType = Object.entries(unloadPackageTypes).filter((itemType) => {
    return itemType[1] === unloading.PackageType;
  })[0]

  const translatedCarcassType = Object.entries(carcassTypes).filter((itemType) => {
    return itemType[1] === unloading.CarcassType;
  })[0]

  const loadingTypeList = getTranslatedConstant('loadingTypesList');
  const translatedLoadingType = loadingTypeList.filter((itemType) => {
    return itemType.Id === unloading.LoadingType;
  })[0]

  const onClickCompleteUnloading = (e) => {
    e.preventDefault();

    unloadingsService
      .completeUnloading(unloading.Id)
      .then((response) => {

        notification.success({
          message: i18n.t('components.notification.titles.completeUnloading'),
          description: response.message
        });

        appContext.setIsNeedUpdateUnloadingList(true);

      }).catch((error) => {

      notification.error({
        message: i18n.t('components.notification.titles.completeUnloading'),
        description: error
      });

      appContext.setIsNeedUpdateUnloadingList(true);
    })

  }

  const onClickCancelUnloading = (e) => {
    e.preventDefault();

    unloadingsService
      .cancelUnloading(unloading.Id)
      .then((response) => {

        notification.success({
          message: i18n.t('components.notification.titles.cancelUnloading'),
          description: response.message
        });

        appContext.setIsNeedUpdateUnloadingList(true);

      }).catch((error) => {

      notification.error({
        message: i18n.t('components.notification.titles.cancelUnloading'),
        description: error
      });

      appContext.setIsNeedUpdateUnloadingList(true);
    })

  }

  const onClickStartUnloading = (e) => {
    e.preventDefault();

    unloadingsService
      .startUnloading(unloading.Id)
      .then((response) => {

        notification.success({
          message: i18n.t('components.notification.titles.startUnloading'),
          description: response.message
        });

        appContext.setIsNeedUpdateUnloadingList(true);
      }).catch((error) => {

      notification.error({
        message: i18n.t('components.notification.titles.startUnloading'),
        description: error
      });

      appContext.setIsNeedUpdateUnloadingList(true);
    })

  }

  const onClickShowModalDriverInfo = (e) => {
    e.preventDefault();
    setShowDriverModalInfo(true);
  };

  if (unloading != null && unloading.Driver != null) {
    btnShowDriverInfo = (
      <>
        <a className="action-button typical-btn-blue" onClick={onClickShowModalDriverInfo}>
          {i18n.t('components.unloadingItemContent.buttons.driverInfo')}
        </a>
        <ModalDriverInfoLite
          isShow={showModalDriverInfo}
          setIsShow={setShowDriverModalInfo}
          driver={unloading.Driver}
        />
      </>
    );
  }

  if (user.isAccessTo(CHANGE_STATUS_UNLOADING) && unloading.Status === UNLOADING_PLANNED) {
    btnStartUnloading = (
      <React.Fragment key={`start-unloading-${unloading.Id}`}>
        <button
          className="action-button"
          onClick={onClickStartUnloading}
        >
          {i18n.t('components.unloadingItemContent.buttons.startUnloading')}
        </button>
      </React.Fragment>
    );
  }

  if (user.isAccessTo(CHANGE_STATUS_UNLOADING) && unloading.Status === UNLOADING_ON_UNLOADING) {
    btnCompleteUnloading = (
      <React.Fragment key={`complete-unloading-${unloading.Id}`}>
        <button
          className="action-button"
          onClick={onClickCompleteUnloading}
        >
          {i18n.t('components.unloadingItemContent.buttons.completeUnloading')}
        </button>
      </React.Fragment>
    );
  }

  if (user.isAccessTo(CANCEL_UNLOADING) && unloading.Status !== UNLOADING_ON_UNLOADING && unloading.Status !== UNLOADING_CANCELED && unloading.Status !== UNLOADING_COMPLETED) {
    btnCancelUnloading = (
      <React.Fragment key={`cancel-unloading-${unloading.Id}`}>
        <button
          className="action-button typical-btn-red"
          onClick={onClickCancelUnloading}
        >
          {i18n.t('components.unloadingItemContent.buttons.cancelUnloading')}
        </button>
      </React.Fragment>
    )
  }

  if (user.isAccessTo(ARCHIVE_UNLOADING) && unloading.Status !== UNLOADING_CANCELED && unloading.Status !== UNLOADING_COMPLETED) {
    btnCompleteUnloading = (
      <React.Fragment key={`complete-unloading-${unloading.Id}`}>
        <button
          className="action-button"
          onClick={onClickCompleteUnloading}
        >
          {i18n.t('components.unloadingItemContent.buttons.archiveUnloading')}
        </button>
      </React.Fragment>
    )
  }

  return (
    <div className={`item-view   non-bot-bord clrfx`}>
      <div className="col s1">
        <div className="top-view">
          <div className="citi-info">
            <div className='citi end' title={unloading.DistributionCenter.Name}>
              <span className='citi-name'>{unloading.DistributionCenter.Name}</span>
            </div>
          </div>
        </div>
        <div className={`bot-view ${contentVisible ? "full-view" : ""}`}>
          <div className="ens">
            {isUserStaff &&
              <div className="info-line">
                <div className="info-line--title">{i18n.t('components.unloadingItemContent.fields.dateCreated')}</div>
                <div className="info-line--desc"><FullDate date={unloading.DateCreated}/></div>
              </div>
            }
            <div className="info-line">
              <div className="info-line--title">{i18n.t('components.unloadingItemContent.fields.company')}</div>
              {/* <div className="info-line--desc">{delivery.CustomerCompany}</div> */}
            </div>
          </div>
        </div>
      </div>
      <div className="col s2">
        <div className="top-view">
          <div className="col-pos-top">
            <div className="informer-item">
              <div className="h-informer">{i18n.t('components.unloadingItemContent.fields.suplierName')}</div>
              <div className="b-informer">{unloading.SuplierName}</div>
            </div>
            <div className='informer-item' style={{marginTop: "10px"}}>
              <div className='h-informer'>{i18n.t('components.unloadingItemContent.fields.suplierINN')}</div>
              <div className="b-informer">{unloading.SuplierINN}</div>
            </div>
          </div>
          <div className="col-pos-bot ">
            <div className="double-bot clrfx">

            </div>
          </div>
        </div>
      </div>
      <div className="col s3">
        <div className="top-view">

          <div className="col-pos-top">
            <div className="triple-bot clrfx">
              <div className="informer-item">
                <div className="h-informer">{i18n.t('components.unloadingItemContent.fields.weight')}</div>
                <div className="b-informer">
                  <div className="inf">{(unloading.Weight / 1000).toFixed(2)} т.</div>
                </div>
              </div>
              <div className="informer-item">
                <div className="h-informer">{i18n.t('components.unloadingItemContent.fields.loadingType')}</div>
                <div className="b-informer">
                  <div className="inf">
                    {translatedLoadingType? translatedLoadingType.Name : unloading.LoadingType}
                  </div>
                </div>
              </div>
              <div className="informer-item">
                <div className="h-informer">{i18n.t('components.unloadingItemContent.fields.carcassType')}</div>
                <div className="b-informer">
                  <div className="inf">{
                    unloading.CarcassType ?
                      translatedCarcassType? i18n.t(`constants.mode.${translatedCarcassType[0]}`): unloading.CarcassType :
                      '-'
                  }</div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-pos-bot ">
            <div className="triple-bot clrfx">
              <div className="informer-item">
                <div className="h-informer">{i18n.t('components.unloadingItemContent.fields.packageType')}</div>
                <div className="b-informer">
                  <div className="inf">{translatedPackageType? i18n.t(`constants.unloadPackageTypes.${translatedPackageType[0]}`) : unloading.PackageType}</div>
                </div>
              </div>
              <div className="informer-item">
                <div className="h-informer">{i18n.t('components.unloadingItemContent.fields.palletsCount')}</div>
                <div className="b-informer">
                  <div
                    className="inf">{unloading.PalletsCount != null && unloading.PalletsCount > 0 ? unloading.PalletsCount : '-'}</div>
                </div>
              </div>
              <div className="informer-item">
                <div className="h-informer">{i18n.t('components.unloadingItemContent.fields.volume')}</div>
                <div className="b-informer">
                  <div
                    className="inf">{unloading.Volume != null && unloading.Volume > 0 ? unloading.Volume : '-'}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="col s4">
        <div className="top-view">
          {/* <a href="#" onClick={toggleContentVisible}
                            className={`view-other-info ${contentVisible ? "open" : ""}`}> </a> */}
          <div className="informer-item pricer">
            <div className="h-informer">{i18n.t('components.unloadingItemContent.fields.info')}</div>
            <div className="b-informer">
              {unloading.DateBooked && unloading.DateBooked &&
                <div className="price-line clrfx">
                  <div className="ls">{i18n.t('components.unloadingItemContent.fields.dateBooked')}</div>
                  <div className="rs">
                    <ShortDate date={unloading.DateBooked}/>
                    <><br/>{unloading.DateBooked.split(' ')[1]}</>
                  </div>
                </div>
              }
              {unloading.StartUnloadingTime && unloading.StartUnloadingTime !== null ?
                <div className="price-line clrfx" style={{marginTop: '10px'}}>
                  <div className="ls">{i18n.t('components.unloadingItemContent.fields.startUnloading')}</div>
                  <div className="rs">
                    <ShortDate date={unloading.StartUnloadingTime}/>
                    <><br/>{unloading.StartUnloadingTime.split(' ')[1]}</>
                  </div>
                </div> : null
              }

              {unloading.DateCompleted != null ?
                <div className="price-line clrfx" style={{marginTop: '10px'}}>
                  <div className="ls">{i18n.t('components.unloadingItemContent.fields.endUnloading')}</div>
                  <div className="rs">
                    <ShortDate date={unloading.DateCompleted}/>
                    <><br/>{unloading.DateCompleted.split(' ')[1]}</>
                  </div>
                </div> : null
              }
              {unloading.DateCanceled &&
                <div className="price-line clrfx" style={{marginTop: '10px'}}>
                  <div className="ls">{i18n.t('components.unloadingItemContent.fields.dateCanceled')}</div>
                  <div className="rs">
                    <ShortDate date={unloading.DateCanceled}/>
                    <><br/>{unloading.DateCanceled.split(' ')[1]}</>
                  </div>
                </div>
              }
              {unloading.DateCreated && unloading.Status === UNLOADING_CANCELED &&
                <div className="price-line clrfx" style={{marginTop: '10px'}}>
                  <div className="ls">{i18n.t('components.unloadingItemContent.fields.dateCreatedShort')}</div>
                  <div className="rs">
                    <ShortDate date={unloading.DateCreated}/>
                    <><br/>{unloading.DateCreated.split(' ')[1]}</>
                  </div>
                </div>
              }
            </div>
          </div>
          {btnShowDriverInfo}
          {btnStartUnloading}
          {btnCompleteUnloading}
          {btnCancelUnloading}
        </div>
      </div>
    </div>
  );
}
